/**
 * Browser stub for Node `url`, used by @o3co/ts.hocon require resolution.
 * Re-exports the rollup node polyfill and adds a `pathToFileURL` stub — ts.hocon
 * only calls it on the file-include/createRequire path, which is unused for string parsing.
 */
export * from 'rollup-plugin-node-polyfills/polyfills/url';
export { default } from 'rollup-plugin-node-polyfills/polyfills/url';

export function pathToFileURL(path) {
  return { href: `file://${path}`, pathname: String(path) };
}
